/*
  Adapter to make checkbox compatible with Rsuite Form
*/

import type { FormControlProps } from 'rsuite'

import React, { useCallback } from 'react'

import { Input, Form } from 'rsuite'

export interface FormControlColorPickerProps extends FormControlProps {
  inputClassName?: string
}

export function InputColorPicker (props: FormControlColorPickerProps) {
  const { inputClassName, defaultValue, value, onChange, ...rest } = props
  const handleChange = useCallback(
    (value: string, event: any) => {
      onChange?.(value, event)
    },
    [ onChange ]
  )
  return (
    <Input
      className={inputClassName}
      value={value}
      type="color"
      onChange={handleChange}
    />
  )
}

export default function FormControlColorPicker (
  props: FormControlColorPickerProps
) {
  return <Form.Control {...props} accepter={InputColorPicker} />
}
